import { Typography } from "@mui/material";
import * as React from "react";
import LabTabs from "../Components/LabTabs";
import "./index.css";
import introFood from "@/assets/img/foodlens.png";
import { useTranslation } from "react-i18next";

function LogIn() {
	const { t } = useTranslation();
	type Value = string;
	const [value, setValue] = React.useState<Value>("2");

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		setValue(newValue);
	};
	// 현재 창 너비 추적용
	const [innerWidth, setInnerWidth] = React.useState(window.innerWidth);

	React.useEffect(() => {
		const resizeListener = () => {
			setInnerWidth(window.innerWidth);
		};
		window.addEventListener("resize", resizeListener);
	});

	return (
		<>
			{innerWidth >= 1030 ? (
				<div style={{ width: "calc(100% - 460px)" }}>
					<div className="LoginContainer">
						{value === "2" ? (
							<h1 className="signInheader">{t("login.title")}</h1>
						) : (
							<div className="signUpheader">
								<h1 className="signUpSubText">{t("login.join_title")}</h1>
								<Typography>{t("login.join_message")}</Typography>
							</div>
						)}
						<LabTabs value={value} handleChange={handleChange} />
						<div style={{ display: "flex", margin: "auto" }}>
							<a
								href="https://www.doinglab.com/ko/about/terms_of_services"
								target="_blank"
								rel="noreferrer"
								style={{
									textDecoration: "none",
									color: "#8b95a1",
									fontSize: "13px",
								}}
							>
								<span style={{ marginRight: "1rem", cursor: "pointer" }}>
									{t("login.terms_of_services")}
								</span>
							</a>
							<div
								style={{
									width: "1px",
									height: "10.5px",
									backgroundColor: "#898989",
								}}
							/>
							<a
								href="https://www.doinglab.com/ko/about/privacy_policy"
								target="_blank"
								rel="noreferrer"
								style={{
									textDecoration: "none",
									color: "#8b95a1",
									fontSize: "13px",
								}}
							>
								<span style={{ marginLeft: "1rem", cursor: "pointer" }}>
									{t("login.privacy_pollcy")}
								</span>
							</a>
						</div>
					</div>
					<div
						style={{
							position: "absolute",
							display: "inline-table",
							top: 0,
							right: 0,
							bottom: 0,
							padding: "80px 40px",
							width: "460px",
							backgroundColor: "#F7F7F7",
						}}
					>
						<div style={{ fontSize: "30px", whiteSpace: "pre-wrap" }}>
							{t("login.guide_title")}
						</div>
						<div
							style={{
								marginTop: "0.7rem",
								fontSize: "1rem",
								lineHeight: "1.75rem",
								whiteSpace: "pre-wrap",
							}}
						>
							{t("login.guide_additional_explanation")}
						</div>
						<ul
							style={{
								listStyleType: "none",
								marginTop: "2rem",
								whiteSpace: "pre-wrap",
							}}
						>
							<li style={{ display: "flex" }}>
								<div
									style={{
										marginRight: "0.5rem",
										cursor: "default",
										userSelect: "none",
									}}
								>
									&#x2713;
								</div>
								<div>{t("login.guide_list_1")}</div>
							</li>
							<li style={{ display: "flex", marginTop: "1rem" }}>
								<div
									style={{
										marginRight: "0.5rem",
										cursor: "default",
										userSelect: "none",
									}}
								>
									&#x2713;
								</div>
								<div style={{ lineHeight: "1.5rem" }}>
									{t("login.guide_list_2")}
								</div>
							</li>
							<li style={{ display: "flex", marginTop: "1rem" }}>
								<div
									style={{
										marginRight: "0.5rem",
										cursor: "default",
										userSelect: "none",
									}}
								>
									&#x2713;
								</div>
								<div>{t("login.guide_list_3")}</div>
							</li>
							<li style={{ display: "flex", marginTop: "1rem" }}>
								<div
									style={{
										marginRight: "0.5rem",
										cursor: "default",
										userSelect: "none",
									}}
								>
									&#x2713;
								</div>
								<div>{t("login.guide_list_4")}</div>
							</li>
						</ul>
						<div style={{ marginTop: "3rem", userSelect: "none" }}>
							<img
								src={introFood}
								alt=""
								width={350}
								height={598}
								draggable={false}
							/>
						</div>
					</div>
				</div>
			) : (
				<div className="LoginContainer">
					{value === "2" ? (
						<h1 className="signInheader">{t("login.join_title")}</h1>
					) : (
						<div className="signUpheader">
							<h1 className="signUpSubText">{t("login.join_title")}</h1>
							<Typography>{t("login.join_message")}</Typography>
						</div>
					)}
					<LabTabs value={value} handleChange={handleChange} />
					<div style={{ display: "flex", margin: "auto" }}>
						<a
							href="https://www.doinglab.com/ko/about/terms_of_services"
							target="_blank"
							rel="noreferrer"
							style={{
								textDecoration: "none",
								color: "#8b95a1",
								fontSize: "13px",
							}}
						>
							<span style={{ marginRight: "1rem", cursor: "pointer" }}>
								{t("login.terms_of_services")}
							</span>
						</a>
						<div
							style={{
								width: "1px",
								height: "10.5px",
								backgroundColor: "#898989",
							}}
						/>
						<a
							href="https://www.doinglab.com/ko/about/privacy_policy"
							target="_blank"
							rel="noreferrer"
							style={{
								textDecoration: "none",
								color: "#8b95a1",
								fontSize: "13px",
							}}
						>
							<span style={{ marginLeft: "1rem", cursor: "pointer" }}>
								{t("login.privacy_pollcy")}
							</span>
						</a>
					</div>
				</div>
			)}
		</>
	);
}

export default LogIn;
